import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  confirmBox: {
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 6,
    padding: '6px 12px',
    marginTop: 8,
    gap: 8,
  },
  confirmDot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: theme.palette.error.main,
    flexShrink: 0,
  },
  loadingIcon: {
    marginRight: 8,
  },
  confirmPaper: {
    borderRadius: 12,
    border: 'none',
    overflow: 'hidden',
  },
}))

export default useStyles
